import React from 'react';
import { View } from 'react-native';
import { CommonStyles } from '../../styles';
import AirChangeSummaryList from './AirChangeSummaryList';

const InvoiceSummaryList = ({ airList, carList, hotelList, passengers, change, railList }) => {
  return (
    <View style={CommonStyles.flex1}>
      {airList &&
        airList.map((response, index) => (
          <AirChangeSummaryList
            onChange={change}
            key={index}
            price={response.TotalCost}
            response={response}
            onSelect={() => {}}
          />
        ))}
    </View>
  );
};
export default InvoiceSummaryList;
